import React from "react";
import { cn } from "@/lib/utils";

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body" | "large" | "small";
  as?: keyof React.JSX.IntrinsicElements;
  children: React.ReactNode;
}

const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  ({ className, variant = "body", as, children, ...props }, ref) => {
    const variantClasses = {
      h1: "h1 text-[var(--h1-size)]",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      body: "text-body",
      large: "text-lg",
      small: "text-small",
    };

    const defaultElements = {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      body: "p",
      large: "p",
      small: "p",
    };

    const Component = (as || defaultElements[variant]) as keyof React.JSX.IntrinsicElements;

    return React.createElement(
      Component,
      {
        className: cn(variantClasses[variant], className),
        ref,
        ...props,
      },
      children
    );
  }
);

Typography.displayName = "Typography";

export { Typography };
